module.exports = __webpack_public_path__ + "img/schets-6.8d78997a.jpg";